<template>
    <button
        type="button"
        class="el-button"
        @click="handleClick"
        :class="[
        type?'el-button--'+type:'',
        buttonSize?'el-button--'+buttonSize:'',
        {
            'is-disabled':disabled,
            'is-plain':plain
        }]"
    >
        <template v-if="$slots.icon">
            <slot name="icon"></slot>
        </template>
        <template v-else-if="icon">
            <font-awesome-icon :icon="icon"></font-awesome-icon>
        </template>
        <span v-if="$slots.default" style="margin-left:6px;"><slot></slot></span>
    </button>
</template>

<script>
export default {
    props:{
        icon:{
            type:String
        },
        type:{
            type:String,
            default:'default',
        },
        size:String,
        plain:Boolean,
        disabled:{
            type:Boolean,
            default:false
        }
    },
    computed:{
        buttonSize(){
            return this.size?this.size:'small';
        }
    },
    methods:{
        handleClick(evt){
            if(this.disabled) return;
            this.$emit('click',evt);
        }
    }
};
</script>

<style>
</style>
